<template>
    <div>
        <div v-if="$page.props.flash.success && show" class="alert alert-success alert-dismissible fade show" role="alert">
            {{ $page.props.flash.success }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true" @click="show = false">&times;</span>
            </button>
        </div>
        <div v-if="$page.props.flash.warning && show" class="alert alert-warning alert-dismissible fade show" role="alert">
            {{ $page.props.flash.warning }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true" @click="show = false">&times;</span>
            </button>
        </div>
        <div v-if="$page.props.errors.warning && show" class="alert alert-warning alert-dismissible fade show" role="alert">
            <span v-if="Object.keys($page.props.errors.warning).length === 1">{{$page.props.errors.warning[0]}}</span>
            <span v-else>{{ $page.props.errors.warning.join(',')}}</span>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true" @click="show = false">&times;</span>
            </button>
        </div>
        <div v-if="!hideErrors && ($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show" class="alert alert-danger alert-dismissible fade show" role="alert">
            <div class="flex items-center">
                <div v-if="$page.props.flash.error" class="text-sm font-medium">{{ $page.props.flash.error }}</div>
                <div v-else class="py-4 text-white text-sm font-medium">
                    <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
                    <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
                </div>
            </div>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true" @click="show = false">&times;</span>
            </button>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        hideErrors: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            show: true,
        }
    },
    watch: {
        '$page.props.flash': {
            handler() {
                this.show = true
            },
            deep: true,
        },
    },
}
</script>
